'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/apps", "/apps/list");

  $stateProvider
    .state('apps', {
      url: '/apps',
      template: require('./apps.html'),
      authenticate: true
    })
    .state('apps.list', {
      url: '/list?page',
      template: require('./list/list.html'),
      controller: 'AppsListController',
      controllerAs: 'appsListCtrl',
      authenticate: true
    })
    .state('apps.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'AppsShowController',
      controllerAs: 'appsShowCtrl',
      authenticate: true
    })
    .state('apps.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'AppsAddController',
      controllerAs: 'appsAddCtrl',
      authenticate: true
    })
    .state('apps.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'AppsEditController',
      controllerAs: 'appsEditCtrl',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/apps/apps.routes.js